module.exports = __webpack_public_path__ + "static/media/akar-icons_link-chain.544866e3.svg";